import { useEffect } from 'react'

import { formatToServerDate } from '../../../utilities/date'
import { useUser } from '../../../utilities/hooks/useUser'
import AssetsLayout from '../layout/assets-layout'
import { actions as rawActions, EditAssetsActions } from '../state/edit-asset-slice'
import { useAppSelector } from '../store/hooks'
import { useActions } from '../store/use-actions'

export const AssetAdminWithState = () => {
  const { data: user } = useUser()
  const state = useAppSelector(state => state.editAssets)
  const actions: EditAssetsActions = useActions(rawActions)
  const pagination = {
    pageNumber: state.query.PageNumber,
    pageSize: state.query.PageSize,
    totalRows: state.numTotalAssets
  }
  useEffect(() => {
    actions.init()
  }, [actions])

  const onSaveExDates = (dates: Date[]) => {
    const datesStr = dates.map(item => formatToServerDate(item))
    actions.saveExDates(datesStr)
  }
  const onNotificationClose = () => {
    actions.resetExDateNotification()
  }

  const canUserSave =
    user.organisation.organisationType === 'Administrator' ||
    user.roles.includes('BankAdmin') ||
    user.roles.includes('Administrator')

  const onPaginationChange = updatedPagination => {
    actions.setPage(updatedPagination)
  }

  return (
    <AssetsLayout
      actions={actions}
      assetPriceHistory={state.assetPriceHistory}
      assets={state.assets}
      availableAssetClasses={state.availableAssetClasses}
      availableCptyIds={state.availableCptyIds}
      availableCurrencies={state.availableCurrencies}
      availableStrategies={state.availableStrategies}
      canProceed={canUserSave && state.canProceed}
      canUserSave={canUserSave}
      errors={state.errors}
      exDateNotification={state.exDateNotification}
      isLoading={state.isLoading}
      isNew={state.isNew}
      numTotalAssets={state.numTotalAssets}
      pagination={pagination}
      saveSuccess={state.saveSuccess}
      selectedAsset={state.selectedAsset}
      serverErrors={state.serverErrors}
      onAssetSearch={searchTerm => actions.search(searchTerm)}
      onChangeStrategyPermission={(id, val) => actions.setStrategyPermission({ id, val })}
      onFundManagerRenamed={() => actions.init()}
      onNotificationClose={onNotificationClose}
      onPaginationChange={onPaginationChange}
      onSaveAsset={() => actions.saveAsset()}
      onSaveExDates={onSaveExDates}
      onSelectAsset={id => actions.setSelectedAsset(id)}
      onSelectNewAsset={() => actions.setIsNew()}
    />
  )
}
